<template>
  <div class="solutions">
    <div class="title">{{$t('meg.solutions')}}</div>
    <p style="font-size: .175rem;color: #818AA0;line-height: .1875rem;">Platform Solutions</p>
    <div class="soluMain">
      <div style="width: 7.125rem;">
        <h1 style="font-size: .6rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 800;color: #002FA7;">{{$t('meg.MRIssystem')}}</h1>
        <p class="ppp" style="margin-top: .775rem;">{{$t('meg.developed')}}</p>
        <p class="ppp" style="margin-top: .775rem;">{{$t('meg.unit')}}</p>
      </div>
      <div class="videoBox">
        <div class="video" style="position: relative;">
          <!-- <videoPlay ref="aplayVideo" :src="video"  v-bind="options"  @play="onPlay"/> -->
          <video src="../../../assets/solution.mp4" autoplay="true"
          loop="true"
          muted="true"
          object-fit="fill"
          playsinline="true"
          webkit-playsinline="true"
          x5-playsinline="true"
          x5-video-player-type="h5"
          x5-video-orientation="landscape|portrait"
          x-webkit-airplay="deny"
          disableRemotePlayback="true" style="width: 100%;"></video>
        </div>
      </div>
    </div>
    <div class="mangeBox">
      <li>
        <img src="../../../assets/newImg/M.png" alt="" style="margin-left: .1875rem;width: .7625rem;height: .7625rem;">
        <span style="font-size: .225rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #FFFFFF;margin-top: .125rem;">Multi-style</span>
        <span style="font-size: .225rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #FFFFFF;">多款式</span>
      </li>
      <li>
        <img src="../../../assets/newImg/R.png" alt=""  style="margin-left: .5rem;width: .7625rem;height: .7625rem;">
        <span style="font-size: .225rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #FFFFFF;margin-top: .125rem;">Rapid-Production</span>
        <span style="font-size: .225rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #FFFFFF;">快速生产</span>
      </li>
      <li>
        <img src="../../../assets/newImg/I.png" alt=""  style="margin-left: .875rem;width: .7625rem;height: .7625rem;">
        <span style="font-size: .225rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #FFFFFF;margin-top: .125rem;">Intelligent-Management</span>
        <span style="font-size: .225rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #FFFFFF;">智能管理</span>
      </li>
    </div>
    <div class="bottom"></div>
  </div>
</template>

<script setup>
// 视频播放组件
import "vue3-video-play/dist/style.css";
import {videoPlay} from "vue3-video-play";

import {ref,reactive} from "vue";
//事件示例
const onPlay = () => {
};

const video = require("../../../assets/solution.mp4")

const options = reactive({
    width: '100%', //播放器高度
    height: '100%', //播放器高度
    color: "#409eff", //主题色
    title: "", //视频名称
    webFullScreen:false,//网页全屏
    speed:true,//是否支持快进快退
    currentTime:0,//跳转到固定播放时间(s)
    muted:false,//静音
    autoPlay: true, //自动播放
    loop:false,//循环播放
    mirror:false,//镜像画面
    control: true, //是否显示控制器
    ligthOff:false,//关灯模式
    volume:0.3,//默认音量0-1
    src: '', //视频源
    poster: '', //封面
    speedRate: [1.0,1.25,1.5,2.0], // 可选的播放速度
    controlBtns: [
    "audioTrack",//音轨切换按钮
    "quality",//视频质量切换按钮
    "speedRate",//速率切换按钮
    "volume",//音量
    "setting",//设置
    "pip",//画中画按钮
    "pageFullScreen",//网页全屏按钮
    "fullScreen",//全屏按钮
  ], //显示所有按钮,

})

</script>

<style scoped>
.title {
    font-size: .3rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    margin-top: .8625rem;
}
.soluMain {
  margin-top: .75rem;
  display: flex;
  margin-left: 2rem;
  text-align: left;
}
.ppp {
  font-size: .2rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  color: #000000;
  line-height: .5125rem;
  text-align: justify;
}
.videoBox {
  /* width: 13.125rem;
  height: 7.1625rem; */
  background: #F6F7FB;
  border-radius: .25rem .25rem .25rem .25rem;
  opacity: 1;
  margin-left: 1.375rem;
  z-index: 99;
}
.mangeBox {
  height: 3.0625rem;
  width: 17rem;
  background: url("../../../assets/newImg/mangeBox.png") no-repeat;
  display: flex;
  justify-content: space-around;
}
.video {
  /* width: 1002px; */
  /* height: 6.475rem; */
  /* background: url("../../../assets/newImg/liucheng.png") no-repeat; */
  border-radius: .25rem .25rem .25rem .25rem;
  margin: .325rem;
}
.mangeBox li {
  display: flex;
  flex-direction: column;
  margin-top: .775rem;
}
.bottom {
  height: 11.8rem;
  background: url("../../../assets/newImg/lunbo3.jpg") no-repeat;
  background-size: 100% 100%;
}
</style>
